"use client";

import Link from "next/link";
import { PlugStamp } from "./components/PlugStamp";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className="min-h-screen bg-[var(--color-ink)] text-[var(--color-bone)] grid place-items-center px-6 py-20">
      <div className="flex max-w-[520px] flex-col items-center text-center">
        <div className="text-[var(--color-bone)] opacity-90">
          <PlugStamp size={120} />
        </div>

        <h1 className="mt-10 font-display text-[clamp(2.25rem,5vw,3.5rem)] uppercase leading-[0.95]">
          Something broke
        </h1>

        <div className="mono-strip mt-5 text-[var(--color-foil)]">
          {error.digest ?? "unknown"}
        </div>

        <p className="mt-4 max-w-[42ch] text-base leading-relaxed text-[var(--color-bone-dim)]">
          We hit a wall on this one. Try again, or head back to the shop.
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <button
            type="button"
            onClick={() => reset()}
            className="inline-flex items-center gap-2 rounded-sm bg-[var(--color-blood)] px-6 py-3 font-display text-sm uppercase tracking-wider text-[var(--color-bone)] transition hover:brightness-110"
          >
            Try again
          </button>
          <Link
            href="/"
            className="mono-strip text-[var(--color-bone-dim)] hover:text-[var(--color-bone)]"
          >
            ← Back home
          </Link>
        </div>
      </div>
    </main>
  );
}
